function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, cloneElement, forwardRef } from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../common/helpers.js";
import { errorClasses, helperClasses, labelClasses, requiredClasses } from "../../common/classes.js";
const formClasses = cva([]);
const controlClasses = cva([
    'flex',
    'my-3'
], {
    variants: {
        direction: {
            row: [
                'flex-row',
                'gap-x-10'
            ],
            column: [
                'flex-col',
                'gap-y-3'
            ]
        }
    }
});
// use fieldprops? // override error state for consistency
// this might just be renamed to fieldset
// onChange should say which value is selected
/**
 * Field Set - [API](https://scl.sharp.com/?path=/docs/base-fieldset) | [DSM](https://sharphealthcare.notion.site/Inputs-4a77e695a529479fa701e2f3dcdc47e7#c106fc2ccd7249febfb38d2cf82b5e8d)
 *
 * Use this with checkbox or radio controls.
 */ const FieldSet = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { name, label, helperText, error, required, disabled, direction = 'column', className, children } = _param, props = _object_without_properties(_param, [
        "name",
        "label",
        "helperText",
        "error",
        "required",
        "disabled",
        "direction",
        "className",
        "children"
    ]);
    return /*#__PURE__*/ _jsxs("fieldset", _object_spread_props(_object_spread({}, props), {
        ref: ref,
        className: cn(formClasses({
            className
        })),
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsxs("legend", {
                    "aria-disabled": disabled,
                    className: labelClasses({
                        error: Boolean(error),
                        disabled: Boolean(disabled),
                        className: 'font-semibold'
                    }),
                    children: [
                        label,
                        required && /*#__PURE__*/ _jsx("div", {
                            "aria-label": "required",
                            className: requiredClasses({
                                disabled: Boolean(disabled)
                            }),
                            children: "*"
                        })
                    ]
                })
            }),
            helperText && /*#__PURE__*/ _jsx("div", {
                className: helperClasses({
                    className: 'mt-2'
                }),
                children: helperText
            }),
            /*#__PURE__*/ _jsx("div", {
                className: controlClasses({
                    direction
                }),
                children: Children.map(children, (child)=>/*#__PURE__*/ cloneElement(child, _object_spread({
                        name
                    }, disabled && {
                        disabled: true
                    })))
            }),
            error && /*#__PURE__*/ _jsx("div", {
                className: errorClasses(),
                children: error
            })
        ]
    }));
});
export { FieldSet };
